class NavigationReponsive {
  constructor() {
    this.menuBurger = document.querySelector('.wp-header__burger-label');
    this.menuCheckbox = document.querySelector('#hamburger');
    this.menuNavigation = document.querySelector('.wp-header__navigation');
    this.desktopQuery = window.matchMedia('(min-width: 1330px)');
    this.backButton = null;

    if (this.menuBurger && this.menuNavigation) {
      this.bindMenu();
    }

    requestAnimationFrame(() => {
      this.ensureDropdownFallbacks();
      this.bindMobileDropdowns();
      this.bindAccordions();
    });
  }

  ensureDropdownFallbacks() {
    // Prefer Management → Sustainability → Financial among rendered panels.
    const preferred = ['management', 'sustainability', 'financial'];
    const available = new Set(
      Array.from(document.querySelectorAll('.wp-header__dropdowns .wp-header__dropdown'))
        .map((el) => el.getAttribute('data-dropdown'))
        .filter(Boolean)
    );
    const keys = preferred.filter((key) => available.has(key));
    const items = document.querySelectorAll('.wp-header__navigation-main .wp-menu-a--main > .wp-menu-a__item--level-0');

    items.forEach((item, index) => {
      if (item.getAttribute('data-dropdown') || !keys[index]) {
        return;
      }
      const key = keys[index];
      item.setAttribute('data-dropdown', key);
      item.classList.add('wp-menu-a__item--has-dropdown');
    });
  }

  bindMenu() {
    this.menuBurger.addEventListener('click', () => {
      // checkbox toggles via label; sync body/nav classes on next tick
      setTimeout(() => {
        const open = this.menuCheckbox && this.menuCheckbox.checked;
        this.menuNavigation.classList.toggle('wp-header__navigation--active', open);
        document.body.classList.toggle('wp-header-menu-open', open);
        if (!open) {
          this.closePanel();
        }
      }, 0);
    });
  }

  createBackButton() {
    if (this.backButton) {
      return this.backButton;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wp-header__mobile-back';
    button.innerHTML = '<span class="wp-header__mobile-back-icon"></span><span class="wp-header__mobile-back-text">Main menu</span>';

    // Reuse arrow icon from first forward arrow if present
    const arrow = document.querySelector('.wp-menu-a__arrow--forward');
    if (arrow) {
      button.querySelector('.wp-header__mobile-back-icon').innerHTML = arrow.innerHTML;
    }

    button.addEventListener('click', () => this.closePanel());
    this.menuNavigation.insertBefore(button, this.menuNavigation.firstChild);
    this.backButton = button;
    return button;
  }

  bindMobileDropdowns() {
    const triggers = document.querySelectorAll('.wp-header__navigation-main .wp-menu-a__item--has-dropdown');

    triggers.forEach((item) => {
      const key = item.getAttribute('data-dropdown');
      const trigger = item.querySelector('.wp-menu-a__link--level-0');
      const source = document.querySelector(`.wp-header__dropdowns .wp-header__dropdown[data-dropdown="${key}"]`);
      if (!key || !trigger || !source) {
        return;
      }

      const clone = source.cloneNode(true);
      clone.classList.add('wp-header__dropdown--mobile');
      clone.querySelectorAll('.wp-header__dropdown-anchor').forEach((el) => el.remove());
      clone.removeAttribute('hidden');
      clone.id = `${clone.id}-mobile`;
      clone.hidden = true;
      item.appendChild(clone);

      trigger.addEventListener('click', (e) => {
        if (this.desktopQuery.matches) {
          return;
        }

        e.preventDefault();
        this.openPanel(item, clone, trigger);
      });
    });
  }

  openPanel(item, clone, trigger) {
    this.createBackButton();

    document.querySelectorAll('.wp-header__navigation-main .wp-menu-a__item--has-dropdown').forEach((other) => {
      other.classList.remove('wp-menu--active');
      const otherClone = other.querySelector('.wp-header__dropdown--mobile');
      const otherTrigger = other.querySelector('.wp-menu-a__link--level-0');
      if (otherClone) {
        otherClone.hidden = true;
      }
      if (otherTrigger) {
        otherTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    item.classList.add('wp-menu--active');
    clone.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    this.menuNavigation.classList.add('wp-header__navigation--panel-open');
    this.menuNavigation.scrollTop = 0;
  }

  closePanel() {
    document.querySelectorAll('.wp-header__navigation-main .wp-menu-a__item--has-dropdown').forEach((item) => {
      item.classList.remove('wp-menu--active');
      const clone = item.querySelector('.wp-header__dropdown--mobile');
      const trigger = item.querySelector('.wp-menu-a__link--level-0');
      if (clone) {
        clone.hidden = true;
      }
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    document.querySelectorAll('.wp-header__dropdown-group.is-open').forEach((group) => {
      group.classList.remove('is-open');
      const title = group.querySelector('.wp-header__dropdown-group-title');
      if (title) {
        title.setAttribute('aria-expanded', 'false');
      }
    });

    this.menuNavigation.classList.remove('wp-header__navigation--panel-open');
  }

  bindAccordions() {
    document.addEventListener('click', (e) => {
      if (this.desktopQuery.matches) {
        return;
      }

      const title = e.target.closest('.wp-header__dropdown--mobile .wp-header__dropdown-group-title');
      if (!title) {
        return;
      }

      e.preventDefault();
      const group = title.closest('.wp-header__dropdown-group');
      const open = group.classList.contains('is-open');

      const panel = title.closest('.wp-header__dropdown--mobile');
      panel.querySelectorAll('.wp-header__dropdown-group.is-open').forEach((other) => {
        other.classList.remove('is-open');
        const otherTitle = other.querySelector('.wp-header__dropdown-group-title');
        if (otherTitle) {
          otherTitle.setAttribute('aria-expanded', 'false');
        }
      });

      if (!open) {
        group.classList.add('is-open');
        title.setAttribute('aria-expanded', 'true');
      }
    });
  }
}

export default NavigationReponsive;
